import { Drawer as MuiDrawer } from '@material-ui/core'
import React, { useState } from 'react'
import { SidebarButton } from '../orders/SidebarButton'
import { BackofficeTransactionsTabs } from './BackofficePresenter'

export interface DrawerInterface {
  open: boolean
  handleOpenSidebarDrawer: () => void
  handleDrawerClose: () => void
  tabs: any[]
  onTabChange: (tab: BackofficeTransactionsTabs) => void
}

export const Drawer = React.memo(function Drawer({
  open,
  handleOpenSidebarDrawer: handleDrawerOpen,
  handleDrawerClose,
  tabs,
  onTabChange,
}: DrawerInterface): JSX.Element {
  const [activeTab, setActiveTab] = useState<BackofficeTransactionsTabs>('inventoryTransactions')

  const handleTabClick = (tab: BackofficeTransactionsTabs) => {
    setActiveTab(tab)
    onTabChange(tab)
  }

  return (
    <>
      <MuiDrawer variant="permanent" open={open}>
        <div className="w-100 d-flex justify-content-end pe-2">
          {open ? (
            <div className="sidebar-open-close-button-container">
              <i
                onClick={handleDrawerClose}
                className="fa-solid fa-caret-left sidebar-open-close-button"
              ></i>
            </div>
          ) : (
            <div className="sidebar-open-close-button-container">
              <i
                onClick={handleDrawerOpen}
                className="fa-solid fa-caret-right sidebar-open-close-button"
              ></i>
            </div>
          )}
        </div>

        <div className="p-2 mt-2">
          {tabs.map((tab: any) => (
            <SidebarButton
              key={tab.dataTestid}
              label={tab.transKey}
              selected={activeTab === tab.tab}
              onClick={() => handleTabClick(tab.tab)}
              icon={tab.icon}
              sidebarOpen={open}
              dataTestid={tab.dataTestid}
            />
          ))}
        </div>
      </MuiDrawer>
    </>
  )
})
